<template>
  <div class="bar_play" :class="{ 'is-ipad': isIpad }">
    <SidebarItem
      v-for="item in permissionRoutes"
      :key="item.path"
      :item="item"
    />
  </div>
</template>

<script lang="ts" setup>
import { usePermissionStore } from '@/store/modules/permission'
import { sideBarStore } from '@/store/modules/sideBar'
import { useWebSocketStore } from '@/store/modules/websocket'
import { useUserStore } from '@/store/modules/user'
import { isEmpty } from '@/libs/utils/data-checker'
import SidebarItem from './SidebarItem.vue'
import { useRouter } from 'vue-router'
import { provide, computed, watch, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { custFormatDate } from '@/libs/utils/data-jsFn'

const barStore = sideBarStore()
const isIpad = window.isIpad
const userStore = useUserStore()
const router = useRouter()
const permissionStore = usePermissionStore()
const permissionRoutes = computed(() => {
  return permissionStore.getRoutes.map(e => {
    if (e.componentName == '/outpatients') {
      if (barStore.barCountSetting.outpatientShowTodoNumFlag) {
        e.count = barStore.barCounts.outpatientCount
      } else {
        e.count = 0
      }
    }
    if (e.componentName == '/charge') {
      if (barStore.barCountSetting.chargeShowTodoNumFlag) {
        e.count = barStore.barCounts.chargeCount
      } else {
        e.count = 0
      }
    }
    if (e.componentName == '/execute') {
      if (barStore.barCountSetting.executionShowTodoNumFlag) {
        e.count = barStore.barCounts.executionCount
      } else {
        e.count = 0
      }
    }
    if (e.componentName == '/pharmacy') {
      if (barStore.barCountSetting.dispensingShowTodoNumFlag) {
        e.count = barStore.barCounts.pharmacyCount
      } else {
        e.count = 0
      }
    }
    return e
  })
})
const wsStore = useWebSocketStore()

// 工具函数：尝试解析 JSON
const tryParseJson = (str: string) => {
  try {
    return JSON.parse(str)
  } catch (e) {
    return null
  }
}

// 工具函数：通过 URL 下载文件
const downloadByUrl = (url: string) => {
  if (!url) return

  // 使用 iframe 方式下载，不会影响当前页面和 WebSocket 连接
  const iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  iframe.style.width = '0'
  iframe.style.height = '0'
  iframe.src = url
  document.body.appendChild(iframe)

  // 延迟移除 iframe，确保下载已开始
  setTimeout(() => {
    document.body.removeChild(iframe)
  }, 3000)
}

onMounted(() => {
  if (userStore.hasLogged) {
    wsStore.connect()
  }
  barStore.setBarCounts()
  barStore.getBarCountSetting()
})

watch(
  () => (wsStore as any).data,
  (newData: any) => {
    if (newData === 'pong') return
    try {
      const message = tryParseJson((wsStore as any).data) ?? {}

      // 处理 401 下线通知
      if (message.type === '401') {
        // 清除用户信息
        userStore.removeToken()
        permissionStore.initRoutesAsync([])
        router.push({ path: '/loginPage' })
        // 显示确认对话框
        const date = new Date()
        ElMessageBox.alert(
          `你的账号于${custFormatDate(
            date,
            'YYYY-MM-DD HH:mm:ss'
          )}，在其它设备登录,因数据安全和一致性考虑，本设备账号自动退出登录。`,
          '退出登录提示',
          {
            confirmButtonText: '确定',
            type: 'warning',
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
          }
        ).then(() => {
          // 跳转到登录页
          router.push({ path: '/loginPage' })
        })
      }

      // 处理导出文件下载（全局监听）
      if (message.type === 'export' && message?.content) {
        // content 结构：{ uid, messageType, deptId, userId, downloadUrl }
        const parsed = tryParseJson(message?.content)
        if (parsed) {
          const url = parsed.downloadUrl || ''
          if (url) {
            downloadByUrl(url)
          }
        }
      }
    } catch (error) {
      console.error(error)
      // 忽略解析错误，可能不是 JSON 格式的消息
    }
  }
)
</script>
<style lang="scss" scoped>
.bar_play {
  width: 100px;
  height: 100%;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  box-sizing: border-box;
  background-color: var(--white-text);
  border-right: 1px solid var(--border);
}
.bar_play::-webkit-scrollbar {
  width: 0;
  height: 0;
  background: transparent;
}
.bar_play.is-ipad {
  width: 64px;
}
</style>
